import React from 'react';
import {
    Grid,
    Typography,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody
} from '@mui/material';
import Switch from '@mui/material/Switch';
import { useParams } from 'react-router-dom';
import Loader from 'ui-component/Loader';
import usePermission from 'hooks/consume_api/query/usePermission';
import useChangePermission from 'hooks/consume_api/mutation/useChangePermission';

interface IActivity {
    action_name: 'View' | 'Add' | 'Edit' | string;
    module_action_role_id: number;
    permission: boolean;
}
interface IPermission {
    module_name: string;
    activity: IActivity[];
}

const ACTIONS: Array<'View' | 'Add' | 'Edit'> = ['View', 'Add', 'Edit'];

const PermissionList: React.FC = () => {
    const { id: roleId, role_name } = useParams();
    const { data, isFetching } = usePermission(roleId ? Number(roleId) : 0);
    const { mutate } = useChangePermission();

    const handleToggle = (row: IActivity) => {
        mutate({ id: row.module_action_role_id, permission: !row.permission });
    };

    return (
        <Grid sx={{ backgroundColor: 'white', borderRadius: '5px', minHeight: '80vh' }}>
            <Typography variant="h3" sx={{ paddingTop: '20px', marginLeft: '10px', fontWeight: 'normal' }}>
                Permission List for {role_name}
            </Typography>

            {isFetching && <Loader />}

            <TableContainer component={Paper}>
                <Table sx={{ width: '100%' }} aria-label="permission table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">#</TableCell>
                            <TableCell align="left">Module Name</TableCell>
                            <TableCell align="left">View</TableCell>
                            <TableCell align="left">Add</TableCell>
                            <TableCell align="left">Edit</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.data?.map((item: IPermission, index: number) => {
                            // build lookup: View/Add/Edit -> activity row
                            const byAction = item.activity.reduce<Record<string, IActivity>>((acc, cur) => {
                                acc[cur.action_name] = cur;
                                return acc;
                            }, {});

                            return (
                                <TableRow key={`${item.module_name}-${index}`}>
                                    <TableCell align="left">{index + 1}</TableCell>
                                    <TableCell align="left">{item.module_name}</TableCell>

                                    {ACTIONS.map((action) => {
                                        const row = byAction[action];
                                        return (
                                            <TableCell align="left" key={`${item.module_name}-${action}`}>
                                                {row ? (
                                                    <Switch
                                                        checked={!!row.permission}
                                                        onChange={() => handleToggle(row)}
                                                        inputProps={{ 'aria-label': `${item.module_name}-${action}` }}
                                                    />
                                                ) : (
                                                    '-' // action not provided by API
                                                )}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default PermissionList;
